// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from "react";
import { PlasmicJsonListModal } from "./plasmic/cps/PlasmicJsonListModal";
import JsonListItem from "./JsonListItem";

function JsonListModal_(props, ref) {
  const chooseItem = (item) => {
    props.handleChoose(item)
  }
  console.log('props hjson', props)
  return <PlasmicJsonListModal root={{ ref }} {...props} 
    jsonList = {{
      children: props.data.map((item, index) => {
        return <JsonListItem key={index} onClick={() => chooseItem(item)} txt={item.name}></JsonListItem>
      })
    }}
  
  />;
}

const JsonListModal = React.forwardRef(JsonListModal_);

export default JsonListModal;
